'use strict';

export default function chartConfig(scope) {
  'ngInject';

  let chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {text: '1年間の消費実績'},
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        format: '{value:%m月分}'
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kWh]'
      }
    },
    legend: {enabled: false},
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function () {
        let tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月') + "</tspan>";

        let point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + point.series.name + ': ';
        tip_format += point.y + " kWh";
        tip_format += "</span>"

        return tip_format;
      }
    },
    plotOptions: {column: {grouping: false}},
    series: [
      {
        name: '実績',
        events: {
          click: function (event) {
            scope.$state.go(
              'main.demand_report_show.detail',
              {id: scope.id, type: 'active', term: 'monthly', target: event.point.date},
              {reload: true}
            );
          }
        },
        cursor: 'pointer'
      }
    ]
  };

  return chartConfig;
}



// WEBPACK FOOTER //
// ./public/dev/app/active_report/yearly/yearly_active_report.config.js